import { render } from "./UpdateBetLimit.vue?vue&type=template&id=04e08636&scoped=true"
import script from "./UpdateBetLimit.vue?vue&type=script&lang=js"
export * from "./UpdateBetLimit.vue?vue&type=script&lang=js"

import "./UpdateBetLimit.vue?vue&type=style&index=0&id=04e08636&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e08636"]])

export default __exports__